export default () => {
  const copy = document.querySelectorAll('.js-copy-text')

  for (const copied of copy) {
    copied.onclick = function() {
      navigator.clipboard.writeText(copied.dataset.text ?? '')
    }
  }
}